import { debounce } from '@/assets/js/util';
import api from '@/api';
const moment = require('moment');

const DELETE_REQUEST_METHODS = {
  works: 'deleteWork',
  edus: 'deleteEdu',
  orgs: 'deleteOrg',
  opus: 'deleteOpu',
};

export const editorFormMixin = {
  data() {
    return {
      displayAnimation: true,
      clickSaveBtn: false,
    };
  },
  computed: {
    customModuleTitle() {
      const { submodule_info } = this.cvDetail;
      const { custom_sections_titles } = submodule_info;
      return custom_sections_titles[`${this.moduleId}_title`];
    },
  },
  methods: {
    useOptimizationContent(description, item) {
      item.description = description;
    },
    async singleExperienceCheck(data, type) {
      const loading = this.$message({
        iconClass: 'el-icon-loading',
        duration: 0,
        message: '正在检查',
      });
      try {
        const custom_sections = [];
        const {
          submodule_info: { sections_position },
          basic_info: { token },
        } = this.cvDetail;
        const payload = {
          cv_token: token,
          cv_module_data: data,
          module_name: type,
          cv: {
            ...this.cvDetail,
            profile: this.$store.state.editor.profile,
          },
        };

        sections_position.forEach((item) => {
          if (item.id) {
            const module = {
              id: item.id,
              infos: this.$store.state.editor[item.type] || this.$store.state.editor[item.id] || [],
              section: item.type,
            };
            custom_sections.push(module);
          } else {
            payload.cv[item.type] = this.$store.state.editor[item.type];
          }
        });

        payload.cv.custom_sections = custom_sections;
        const res = await api.cvsEditor.getSingleExperienceCheckResult(payload);
        if (res.code === 1000) {
          this.$emit('refreshCheckResult');
        }
      } catch (error) {
        console.log(error);
      } finally {
        loading.close();
      }
    },
    async clickRepairIssue(data, type) {
      const loading = this.$message({
        iconClass: 'el-icon-loading',
        duration: 0,
        message: '正在修复',
      });
      try {
        const res = await api.cvsEditor.repairIssueByAi({
          cv_token: this.cvDetail.basic_info.token,
          cv_module_data: data,
          module_name: type,
        });
        if (res.code === 1000) {
          data.description = res.data.result_content;
          this.$forceUpdate();
          this.$emit('refreshCheckResult');
          return 'success';
        } else {
          this.$message.error(res.message || '请重新尝试');
          return 'error';
        }
      } catch (error) {
        console.log(error);
        this.$message.error('请求超时，请重试');
        return 'error';
      } finally {
        loading.close();
      }
    },
    async clickIgnore(issueItem, item, type) {
      try {
        const payload = {
          cv_token: this.cvDetail.basic_info.token,
          cv_module_data: item,
          module_name: type,
          index: issueItem.index,
        };
        const res = await api.cvsEditor.ignoreCheckIssue(payload);
        if (res.code === 1000) {
          this.$message.success('已忽略');
          issueItem.status = 'obsolete';
          this.$emit('refreshCheckResult');
        }
      } catch (error) {
        console.log(error);
      }
    },
    returnCheckResultList(id, module) {
      return module?.[`${id}`] || [];
    },
    experienceEmpty(type, id, keys) {
      const form = this.$store.state.editor[type]?.find((item) => item.id === id);
      if (!form) return;
      return !keys.some((key) => form[key]);
    },
    checkCustomModuleEmpty(type, id, keys, moduleId) {
      const form = this.$store.state.editor[type]?.find((item) => item.id === id);
      if (!form) return;
      form.lang = this.cvDetail.basic_info.lang;
      form.section_title = this.customModuleTitle;
      form.start_at = form.start_at ? moment.utc(form.start_at) : null;
      form.end_at = form.end_at ? moment.utc(form.end_at) : null;
      if (keys.some((key) => form[key])) {
        this.updateFormCustomExperience(form, moduleId, type);
      } else {
        this.clickRemoveExperience(form, type);
      }
    },
    checkModuleEmpty(type, id, keys) {
      const form = this.$store.state.editor[type]?.find((item) => item.id === id);
      if (!form) return;
      if (keys.some((key) => form[key])) {
        this.updateFormExperience(form, type);
      } else {
        this.clickRemoveExperience(form, type);
      }
    },
    async confirmModuleRename(name, type) {
      const { submodule_info = {} } = this.cvDetail;
      const loading = this.$message({
        iconClass: 'el-icon-loading',
        duration: 0,
        message: '正在修改',
      });
      switch (type) {
        case 'works':
        case 'edus':
        case 'orgs':
        case 'opus':
        case 'extras':
          try {
            const res = await this.$store.dispatch('editor/updateCvDetail', {
              submodule_info: {
                ...submodule_info,
                [`${type}_title`]: name,
              },
              operation_type: 'update_submodule_info',
              skipCheck: true,
            });
            if (res.code === 1000) {
              this.$message.success('修改成功');
              this.$refs.renameModalRef?.close?.();
            } else {
              this.$message.error(res.message);
            }
          } catch (error) {
            console.log(error, 'error');
          } finally {
            loading.close();
          }
          break;
        default:
          try {
            submodule_info.custom_sections_titles[`${type}_title`] = name;
            const res = await this.$store.dispatch('cvsEditor/editCustomTitle', {
              editModuleData: {
                id: type,
              },
              queryData: {
                section_title: name,
              },
            });
            if (res.code === 1000) {
              this.$message.success('修改成功');
              this.$refs.renameModalRef?.close?.();
            } else {
              this.$message.error(res.message);
            }
            this.$store.commit('editor/setCvDetail', {
              ...this.cvDetail,
              submodule_info: {
                ...this.cvDetail.submodule_info,
                custom_sections_titles: submodule_info.custom_sections_titles,
              },
            });
          } catch (error) {
            console.log(error, 'error');
          } finally {
            loading.close();
          }
          break;
      }
    },
    initModuleTitles(type) {
      const { lang } = this.cvDetail?.basic_info || {};
      const titles = this.section_titles?.[type]?.[lang] || [];
      return titles;
    },
    clickRenameModule(type, title) {
      const titles = this.initModuleTitles(type);
      this.$refs.renameModalRef?.show?.({ titles, moduleTitle: title });
    },
    // 基础经历真实删除
    async singleExperienceRealRemove(data, type) {
      try {
        api.cvsEditor[DELETE_REQUEST_METHODS[type]](data.id, {
          cv_token: this.cvDetail.basic_info.token,
        });
      } catch (error) {
        console.log(error, 'error');
      }
    },
    // 自定义经历真实删除
    async singleCustomExperienceRealRemove(id, infoId) {
      try {
        api.cvsEditor.deleteCustomInfo(id, infoId);
      } catch (error) {
        console.log(error, 'error');
      }
    },
    async singleCustomModuleRealRemove(id) {
      try {
        api.cvsEditor.deleteCustom(id);
      } catch (error) {
        console.log(error, 'error');
      }
    },
    // extras 真实删除
    async extrasRealRemove(data) {
      try {
        api.cvsEditor.deleteExtra(data);
      } catch (error) {
        console.log(error, 'error');
      }
    },
    // 基础模块从简历关联中移除
    async baseModuleRemove(type, submodule) {
      const loading = this.$message({
        iconClass: 'el-icon-loading',
        duration: 0,
        message: '正在删除',
      });
      try {
        const ids = JSON.parse(JSON.stringify(this.cvDetail.submodule_info[`${type}_ids`] || []));
        const res = await this.$store.dispatch('editor/updateCvDetail', {
          submodule_info: {
            ...submodule,
            [`${type}_ids`]: [],
            sections_position: submodule.sections_position.filter((item) => item.type !== type),
          },
          operation_type: 'update_submodule_info',
          skipCheck: true,
        });
        if (res.code === 1000) {
          this.$message.success('删除成功');
          // this.$emit(
          //   "editItem",
          //   this.editId.includes("edit") ? this.editId : ""
          // );
          this.$store.commit('editor/setModuleData', {
            type,
            info: [],
          });
          ids.forEach((id) => {
            if (typeof id === 'number') this.singleExperienceRealRemove({ id }, type);
          });
        }
      } catch (error) {
        console.log(error, 'error');
      } finally {
        loading.close();
      }
    },
    // extras 模块删除
    async extrasModuleRemove(submodule) {
      const loading = this.$message({
        iconClass: 'el-icon-loading',
        duration: 0,
        message: '正在删除',
      });
      try {
        this.moduleSequence.forEach((item) => {
          submodule[`${item.key}_id`] = null;
        });
        const res = await this.$store.dispatch('editor/updateCvDetail', {
          submodule_info: {
            ...submodule,
            sections_position: submodule.sections_position.filter((item) => item.type !== 'extras'),
          },
          operation_type: 'update_submodule_info',
          skipCheck: true,
        });
        if (res.code === 1000) {
          this.$message.success('删除成功');
          this.moduleSequence.forEach((item) => {
            if (item.id) {
              this.extrasRealRemove({
                [`${item.key}_id`]: item.id,
              });
            }
          });
        }
      } catch (error) {
        console.log(error, 'error');
      } finally {
        loading.close();
      }
    },
    // 自定义模块从简历关联中删除
    async customModuleRemove(id, submodule) {
      const loading = this.$message({
        iconClass: 'el-icon-loading',
        duration: 0,
        message: '正在删除',
      });
      try {
        const customSectionItem = submodule.sections_position.find((item) => item.id === id);
        const info_ids = JSON.parse(JSON.stringify(customSectionItem.info_ids));

        const res = await this.$store.dispatch('editor/updateCvDetail', {
          submodule_info: {
            ...submodule,
            sections_position: submodule.sections_position.filter((item) => item.id !== id),
            custom_sections_ids: submodule.custom_sections_ids.filter((item) => item !== id),
          },
          operation_type: 'update_submodule_info',
          skipCheck: true,
        });

        if (res.code === 1000) {
          this.$message.success('删除成功');
          this.$store.commit('editor/setModuleData', {
            type: customSectionItem.type === 'custom' ? id : customSectionItem.type,
            info: [],
          });

          info_ids.forEach(async (id) => {
            if (typeof id === 'number') {
              await this.singleCustomExperienceRealRemove(customSectionItem.id, id);
            }
            this.singleCustomModuleRealRemove(customSectionItem.id);
          });
        }
      } catch (error) {
        console.log(error, 'error');
      } finally {
        loading.close();
      }
    },
    // 删除模块
    async clickRemoveModule(type) {
      const submodule = JSON.parse(JSON.stringify(this.cvDetail.submodule_info || {}));
      switch (type) {
        case 'works':
        case 'edus':
        case 'orgs':
        case 'opus':
          this.baseModuleRemove(type, submodule);
          break;
        case 'extras':
          this.extrasModuleRemove(submodule);
          break;
        default:
          this.customModuleRemove(type, submodule);
          break;
      }
    },
    // 经历排序
    async experienceSequenceChange(type, moduleId) {
      const submodule = JSON.parse(JSON.stringify(this.cvDetail.submodule_info || {}));
      switch (type) {
        case 'works':
        case 'edus':
        case 'orgs':
        case 'opus':
          try {
            const ids = this.$store.state.editor[type].map((item) => item.id);
            // 判断是否有编辑中但是未保存的经历
            const isNotSaveExperience = ids.some((id) => id.toString().includes('edit'));
            if (isNotSaveExperience) {
              this.$store.commit('editor/setCvDetail', {
                ...this.cvDetail,
                submodule_info: {
                  ...submodule,
                  [`${type}_ids`]: this.replaceIds(ids, `${type}-edit`, 'virtualId'),
                },
              });
            } else {
              this.$store.dispatch('editor/updateCvDetail', {
                submodule_info: {
                  ...submodule,
                  [`${type}_ids`]: ids,
                },
                operation_type: 'update_submodule_info',
                skipCheck: true,
              });
            }
            this.$refs.EditorRichTextRef?.forEach((item) => {
              item.initTinymceEditor();
            });
          } catch (error) {
            console.log(error, 'error');
          }
          break;
        case 'extras':
          try {
            this.$store.dispatch('editor/updateCvDetail', {
              submodule_info: {
                ...submodule,
                extras_position: this.moduleSequence.map((item) => `${item.key}s`),
              },
              operation_type: 'update_submodule_info',
              skipCheck: true,
            });
          } catch (error) {
            console.log(error);
          }
          break;
        default:
          try {
            const info_ids = this.$store.state.editor[type === 'custom' ? moduleId : type].map((item) => item.id);
            const isNotSaveExperience = info_ids.some((id) => id.toString().includes('edit'));
            if (isNotSaveExperience) {
              submodule.sections_position.forEach((item) => {
                if (item.id === moduleId) {
                  item.info_ids = this.replaceIds(info_ids, `${moduleId}-edit`, 'virtualId');
                }
              });
              this.$store.commit('editor/setCvDetail', {
                ...this.cvDetail,
                submodule_info: submodule,
              });
            } else {
              submodule.sections_position.forEach((item) => {
                if (item.id === moduleId) {
                  item.info_ids = info_ids;
                }
              });
              this.$store.dispatch('editor/updateCvDetail', {
                submodule_info: submodule,
                operation_type: 'update_submodule_info',
                skipCheck: true,
              });
            }
            this.$refs.EditorRichTextRef?.forEach((item) => {
              item.initTinymceEditor();
            });
          } catch (error) {
            console.log(error);
          }
          break;
      }
    },
    // 基础经历从简历关联中移除
    async singleBaseExperienceRemove(data, type, submodule) {
      const infos = this.$store.state.editor[type]?.filter((item) => item.id !== data.id);
      submodule[`${type}_ids`] = submodule[`${type}_ids`].filter((item) => item !== data.id && item !== 'virtualId');
      if (infos.length === 0) {
        // submodule.sections_position = submodule.sections_position.filter((item) => item.type !== type);
      }
      const loading = this.$message({
        iconClass: 'el-icon-loading',
        duration: 0,
        message: '正在删除',
      });
      try {
        const res = await this.$store.dispatch('editor/updateCvDetail', {
          submodule_info: submodule,
          operation_type: 'update_submodule_info',
          skipCheck: true,
        });
        if (res.code === 1000) {
          // const editId =
          //   data.id === this.editId && !this.editId.includes("edit")
          //     ? ""
          //     : this.editId;
          this.$store.commit('editor/setModuleData', {
            type,
            info: infos,
          });
          // this.$emit("editItem", editId);
          this.$message.success('删除成功');
          this.singleExperienceRealRemove(data, type);
        }
      } catch (error) {
        console.log(error, 'error');
      } finally {
        loading.close();
      }
    },
    // 自定义经历从简历关联中移除
    async singleCustomExperienceRemove(data, type, submodule) {
      try {
        let { sections_position = [], custom_sections_ids = [] } = submodule;
        const { id, custom_section_id } = data;
        const customSectionItem = sections_position.find((item) => item.id === custom_section_id);
        const info_ids = customSectionItem.info_ids.filter((item) => item !== id && item !== 'virtualId');
        customSectionItem.info_ids = info_ids;

        if (info_ids.length === 0) {
          // sections_position = sections_position.filter((item) => item.id !== custom_section_id);
          // custom_sections_ids = custom_sections_ids.filter((item) => item !== custom_section_id);
        }

        // 先更新简历
        const res = await this.$store.dispatch('editor/updateCvDetail', {
          submodule_info: {
            ...submodule,
            sections_position,
            custom_sections_ids,
          },
          operation_type: 'update_submodule_info',
          skipCheck: true,
        });

        if (res.code === 1000) {
          this.$message.success('删除成功');
          // 从store中删除
          const infos = this.$store.state.editor[type].filter((item) => item.id !== id);
          this.$store.commit('editor/setModuleData', {
            type,
            info: infos,
          });
          // 删除经历
          this.singleCustomExperienceRealRemove(custom_section_id, id);

          // 判断如果经历为空，则删除自定义模块
          if (info_ids.length === 0) {
            // this.singleCustomModuleRealRemove(custom_section_id);
          }
        }
      } catch (error) {
        console.log(error, 'error');
      }
    },
    // 把经历从简历关联中移除
    async removeExperienceFromResume(data, type) {
      const submodule = JSON.parse(JSON.stringify(this.cvDetail.submodule_info || {}));
      switch (type) {
        case 'works':
        case 'edus':
        case 'orgs':
        case 'opus':
          this.singleBaseExperienceRemove(data, type, submodule);
          break;
        default:
          this.singleCustomExperienceRemove(data, type, submodule);
          break;
      }
    },
    // 点击删除经历
    async clickRemoveExperience(item, type) {
      try {
        if (item.id?.toString()?.includes('edit')) {
          //  这里后续可以优化一下，不调用接口更新简历，走到这里的时候应该是创建模块，并且在没有保存时候直接删除，可以前端直接更新store并且删除刚创建的自定义模块
          const info = this.$store.state.editor[type]?.filter((value) => !value.id?.toString()?.includes('edit'));

          this.$store.commit('editor/setCvDetail', {
            ...this.cvDetail,
            submodule_info: {
              ...this.cvDetail.submodule_info,
              [`${type}_ids`]: info.map((item) => item.id),
            },
          });

          this.$store.commit('editor/setModuleData', {
            type,
            info,
          });
        } else {
          this.removeExperienceFromResume(item, type);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async updateBaseForm(payload, type, operation) {
      const { submodule_info = {} } = this.cvDetail;
      const result = await this.$store.dispatch('editor/updateExperience', { type, payload, displayLoading: false });
      this.$store.dispatch('editor/updateCvDetail', {
        submodule_info,
        operation_type: 'update_submodule_info',
        skipCheck: true,
      });
      if (operation === 'click') {
        this.clickSaveBtn = true;
        this.$emit('editItem', '');
        let timer = setTimeout(() => {
          this.clickSaveBtn = false;
          clearTimeout(timer);
        }, 300);
      }
      return result;
    },
    async updateCustomForm(payload, operation) {
      const { submodule_info = {} } = this.cvDetail;
      const res = await this.$store.dispatch('editor/updateCustomInfo', { ...payload, displayLoading: false });
      this.$store.dispatch('editor/updateCvDetail', {
        submodule_info,
        operation_type: 'update_submodule_info',
        skipCheck: true,
      });

      if (operation === 'click') {
        this.clickSaveBtn = true;
        this.$emit('editItem', '');
        let timer = setTimeout(() => {
          this.clickSaveBtn = false;
          clearTimeout(timer);
        }, 300);
      }
      return res;
    },
    replaceIds(arr, oldId, newId) {
      return arr.map((item) => (item === oldId ? newId : item));
    },
    async createCustomExperienceAndUpdateResume(payload, moduleId, type, isNotUserCustomModule, operation) {
      try {
        const { id, ...rest } = payload;
        let createCustomModuleResult = null;
        if (isNotUserCustomModule) {
          createCustomModuleResult = await this.$store.dispatch('editor/createCustom', {
            category: type,
            section_title: this.cvDetail.submodule_info.custom_sections_titles[`${moduleId}_title`],
            lang: this.cvDetail.basic_info.lang,
            displayLoading: false,
          });
          if (createCustomModuleResult?.code !== 1000) return this.$message.error('创建模块失败');
        }

        const res = await this.$store.dispatch('editor/createCustomInfo', {
          id: createCustomModuleResult?.data?.custom_section?.id || moduleId,
          payload: rest,
          displayLoading: false,
        });

        let result = null;

        if (res.code === 1000 && res.data?.info?.id) {
          this.displayAnimation = false;
          const { submodule_info = {} } = this.cvDetail;
          const { sections_position = [] } = submodule_info;
          sections_position.forEach((item) => {
            if (item.id === moduleId) {
              // 这里判断一下是不是用户自己的自定义模块
              if (isNotUserCustomModule) {
                item.id = createCustomModuleResult?.data?.custom_section?.id;
                submodule_info.custom_sections_ids = [...submodule_info.custom_sections_ids.filter((item) => item !== moduleId), item.id];
                submodule_info.custom_sections_titles[`${item.id}_title`] = createCustomModuleResult?.data?.custom_section?.title;
                item.info_ids = [res.data?.info?.id];
              } else {
                // 判断是否有未保存的虚拟id
                const hasVirtualId = item.info_ids.some((item) => item === 'virtualId');
                item.info_ids = hasVirtualId ? this.replaceIds(item.info_ids, `virtualId`, res.data?.info?.id) : [...item.info_ids, res.data.info.id];
              }
            }
          });
          if (['template', 'sample'].includes(this.cvDetail.basic_info.kind)) {
            result = await this.$store.dispatch('editor/createCvDetail', {
              payload: {
                ...this.cvDetail,
                submodule_info: {
                  ...submodule_info,
                  sections_position,
                },
              },
              dontReload: true,
            });
          } else {
            result = await this.$store.dispatch('editor/updateCvDetail', {
              submodule_info: {
                ...submodule_info,
                sections_position,
              },
              operation_type: 'update_submodule_info',
              skipCheck: true,
            });
          }

          const sameModule = this.editId.toString()?.includes(`${moduleId}`);
          this.$emit('editItem', operation === 'click' ? '' : sameModule ? res.data.info.id : this.editId);

          if (operation === 'click') {
            this.clickSaveBtn = true;
            let timer = setTimeout(() => {
              this.clickSaveBtn = false;
              clearTimeout(timer);
            }, 300);
          }

          if (isNotUserCustomModule) {
            this.$store.commit('editor/setModuleData', {
              type: type === 'custom' ? `${moduleId}` : type,
              info: [res.data.info],
            });
          } else {
            this.$store.state.editor[type === 'custom' ? `${moduleId}` : type].forEach((item) => {
              if (item.id?.toString()?.includes('edit')) {
                item.id = res.data.info.id;
              }
            });
          }

          const timer = setTimeout(() => {
            this.displayAnimation = true;
            clearTimeout(timer);
          }, 3000);

          return result;
        }
      } catch (error) {
        console.log(error, 'error');
      }
    },
    async createExperienceAndUpdateResume(payload, type, operation) {
      try {
        const { id, ...rest } = payload;
        const res = await this.$store.dispatch('editor/createExperience', {
          type,
          payload: rest,
          displayLoading: false,
        });

        let result = null;

        if (res?.code === 1000 && res?.data?.[type]?.id) {
          this.displayAnimation = false;
          const { submodule_info = {}, basic_info = {} } = this.cvDetail;

          if (['sample', 'template'].includes(basic_info.kind)) {
            const submoduleInfoPayload = {
              ...submodule_info,
              [`${type}_ids`]: this.replaceIds(submodule_info[`${type}_ids`], `virtualId`, res.data[type].id),
            };
            result = await this.$store.dispatch('editor/createCvDetail', {
              payload: {
                ...this.cvDetail,
                submodule_info: submoduleInfoPayload,
              },
              dontReload: true,
            });
          } else {
            // 更新的时候也要判断是否是大牛经历改的
            const hasVirtualId = submodule_info[`${type}_ids`].some((item) => item === 'virtualId');
            const submoduleInfoPayload = {
              ...submodule_info,
              [`${type}_ids`]: hasVirtualId ? this.replaceIds(submodule_info[`${type}_ids`], `virtualId`, res.data[type].id) : [...submodule_info[`${type}_ids`], res.data?.[type]?.id],
            };
            result = await this.$store.dispatch('editor/updateCvDetail', {
              submodule_info: submoduleInfoPayload,
              operation_type: 'update_submodule_info',
              skipCheck: true,
            });
          }
          
          const sameModule = this.editId.toString()?.includes(type);
          this.$emit('editItem', operation === 'click' ? '' : sameModule ? res.data[type].id : this.editId);

          if (operation === 'click') {
            this.clickSaveBtn = true;
            let timer = setTimeout(() => {
              this.clickSaveBtn = false;
              clearTimeout(timer);
            }, 300);
          }

          this.$store.state.editor[type].forEach((item) => {
            if (item.id?.toString()?.includes('edit')) {
              item.id = res.data[type].id;
            }
          });

          const timer = setTimeout(() => {
            this.displayAnimation = true;
            clearTimeout(timer);
          }, 3000);

          return result;
        }
      } catch (error) {
        console.log(error, 'error');
      }
    },
    updateFormExperience: debounce(async function (payload, type, operation) {
      if (this.saveLoading) return;
      this.$emit('changeSaveLoading', true);
      const loading = this.$message({
        iconClass: 'el-icon-loading',
        duration: 0,
        message: '正在保存',
      });
      if (['sample', 'template'].includes(payload.kind)) {
        this.cvDetail.submodule_info[`${type}_ids`] = this.replaceIds(this.cvDetail.submodule_info[`${type}_ids`], payload.id, `virtualId`);
        payload.id = `${type}-edit`;
        delete payload.kind;
      }
      let result = null;
      if (!payload.id?.toString()?.includes('edit')) {
        result = await this.updateBaseForm(payload, type, operation);
      } else {
        result = await this.createExperienceAndUpdateResume(payload, type, operation);
      }
      if (result?.code === 1000) {
        this.$message.success('保存成功');
      }
      loading.close();
      this.$emit('changeSaveLoading', false);
    }, 300),
    updateFormCustomExperience: debounce(async function (payload, moduleId, type, operation) {
      if (this.saveLoading) return;
      this.$emit('changeSaveLoading', true);
      const loading = this.$message({
        iconClass: 'el-icon-loading',
        duration: 0,
        message: '正在保存',
      });

      const isTemplateOrSample = ['sample', 'template'].includes(this.$store.state.editor.moduleKinds[moduleId]);

      const isNotUserCustomModule = isTemplateOrSample;

      if (isNotUserCustomModule) {
        payload.id = `${moduleId}-edit`;
        delete payload.kind;
      }

      let result = null;

      if (payload.id?.toString()?.includes('edit')) {
        result = await this.createCustomExperienceAndUpdateResume(payload, moduleId, type, isNotUserCustomModule, operation);
      } else {
        result = await this.updateCustomForm(payload, operation);
      }

      if (result?.code === 1000) {
        this.$message.success('保存成功');
      }

      loading.close();
      this.$emit('changeSaveLoading', false);
    }, 300),
  },
};
